import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

interface SwipeHintProps {
  className?: string;
  showText?: boolean;
}

const SwipeHint = ({ className, showText = true }: SwipeHintProps) => {
  const [isVisible, setIsVisible] = useState(true);
  const [hasInteracted, setHasInteracted] = useState(false);

  useEffect(() => {
    // Check if user has already seen the hint
    const hasSeenHint = sessionStorage.getItem("swipe-hint-seen");
    if (hasSeenHint) {
      setIsVisible(false);
      setHasInteracted(true);
      return;
    }

    // Hide hint after 4 seconds
    const timer = setTimeout(() => {
      setIsVisible(false);
      sessionStorage.setItem("swipe-hint-seen", "true");
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  const handleInteraction = () => {
    if (!hasInteracted) {
      setIsVisible(false);
      setHasInteracted(true);
      sessionStorage.setItem("swipe-hint-seen", "true");
    }
  };

  if (!isVisible || hasInteracted) return null;

  return (
    <div 
      className={cn(
        "md:hidden absolute inset-x-0 bottom-0 flex items-center justify-center gap-2 py-3 bg-gradient-to-t from-background/80 to-transparent animate-fade-in pointer-events-none z-10",
        className
      )}
      onTouchStart={handleInteraction}
    >
      <div className="flex items-center gap-2 text-muted-foreground animate-pulse-soft">
        <ChevronLeft className="w-4 h-4 animate-bounce-x" />
        {showText && <span className="text-xs font-medium">Swipe to see more</span>}
        <ChevronRight className="w-4 h-4 animate-bounce-x-reverse" />
      </div>
    </div>
  );
};

export default SwipeHint;
